"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const react_intl_1 = require("react-intl");
const notification_context_1 = require("@src/context/notification-context");
const react_router_1 = require("react-router");
const canonical_url_1 = require("./canonical-url");
const Head = (props) => {
    const intl = (0, react_intl_1.useIntl)();
    const NotificationContext = (0, notification_context_1.useNotificationContextValue)();
    const location = (0, react_router_1.useLocation)();
    const { unseenNotificationsCount } = NotificationContext;
    const notificationsTitleString = unseenNotificationsCount > 0 ? `(${unseenNotificationsCount}) ` : '';
    const id = props.id || 'app';
    const canonicalUrl = (0, canonical_url_1.getCanonicalUrl)(props.canonicalPath || `${location.pathname}${location.search}`, process.env.PUBLIC_URL);
    const imageUrl = new URL(props.imageUrl || '/media/images/meta-homepage.jpg', process.env.PUBLIC_URL).href;
    const title = props.title
        ? `${notificationsTitleString}${props.title}`
        : `${notificationsTitleString}${intl.formatMessage({ id: `${id}.head.title` })}`;
    const titleSocial = props.customSocialTitle ? intl.formatMessage({ id: `${id}.head.title.social` }) : title;
    const description = props.description || intl.formatMessage({ id: `${id}.head.description` });
    const descriptionSocial = props.customSocialDescription
        ? intl.formatMessage({ id: `${id}.head.description.social` })
        : description;
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { children: [(0, jsx_runtime_1.jsx)("title", { children: title }), (0, jsx_runtime_1.jsx)("link", { rel: "canonical", href: canonicalUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "og:title", content: titleSocial }), (0, jsx_runtime_1.jsx)("meta", { property: "og:url", content: canonicalUrl }), (0, jsx_runtime_1.jsx)("meta", { name: "description", content: description }), (0, jsx_runtime_1.jsx)("meta", { property: "og:description", content: descriptionSocial }), (0, jsx_runtime_1.jsx)("meta", { property: "og:type", content: props.type || 'website' }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: imageUrl })] }));
};
exports.Head = Head;
